/*============================================================================
  Personal Shopper — v16 + funnel tracking
  Bilingue FR/EN, ordre chronologique produits
  v15 : Q1 instantanée (zéro latence), réponses rapides, flow 3 questions
  v16 : menu d'intentions à l'ouverture (diagnostic Typeform / routine chat / autre)
  Tracking funnel → https://pers-personal-shopper-api.vercel.app/api/event
==============================================================================*/

(function () {
  'use strict';

  /* ---- Funnel tracking → dashboard analytics ---- */
  var PS_EVENTS_URL = 'https://pers-personal-shopper-api.vercel.app/api/event';
  var _psAnswerCount = 0;
  var _psSource = 'direct'; // point d'entrée de la session (fab/banner/header/direct), pour attribuer le funnel
  function psDevice() { return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? 'mobile' : 'desktop'; }
  function psTrackEvent(type, extra) {
    try {
      fetch(PS_EVENTS_URL, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({ type: type }, extra || {})), keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  /* Arrivée sur la page diagnostic : on lit ?src (posé par le menu header, le CTA
     Hero ou l'option « Mon diagnostic » du panel) et on l'envoie en event diagview,
     pour attribuer les entrées du diagnostic Typeform (dashboard Analytics Diagnostic). */
  function trackDiagArrival() {
    if (!/\/pages\/diagnostic/.test(location.pathname)) return;
    var m = /[?&]src=([^&]+)/.exec(location.search);
    psTrackEvent('diagview', { source: m ? decodeURIComponent(m[1]) : 'direct' });
  }

  /*============================================================================
    System prompts FR et EN
  ==============================================================================*/
  var SYSTEM_PROMPT_FR = [
    'Tu es Magali Calmon, co-fondatrice de PERS et directrice de clinique esthétique.',
    'Tu parles directement aux visiteurs du site, à la première personne, avec la précision d\'une experte et la chaleur d\'une femme qui connaît la peau depuis 20 ans.',
    'Tu vouvoies toujours. Tu ne te présentes pas à nouveau, tu as déjà été présentée. Tu vas droit au but.',
    'Tu ne parles pas comme un chatbot. Tu parles comme quelqu\'un qui a passé des milliers d\'heures en consultation.',
    '',
    '---',
    '',
    '## CATALOGUE PERS : 8 produits disponibles (la Crème Légère est temporairement hors stock, ne pas la proposer)',
    '',
    'handle: serum-vitamine-c | Sérum Vitamine C 10% | 80 € | Application : matin',
    'Éclat immédiat, protection anti-âge, correction des taches. Vitamine C stabilisée 10%.',
    '',
    'handle: protection-quotidienne-spf50 | Protection SPF 50+ en Gelée | 44 € | Application : matin (dernière étape)',
    'Protection UVA PA++++, UVB 50+. Texture gel invisible, fini mat. Indispensable pour tous.',
    '',
    'handle: gel-nettoyant | Gel Nettoyant Apaisant | 40 € | Application : matin et soir',
    'Nettoie sans assécher. Centella Asiatica 1%. Convient aux peaux sensibles. Tous profils.',
    '',
    'handle: baume-demaquillant | Baume Démaquillant Éclat | 50 € | Application : soir (première étape)',
    'Première étape du double nettoyage. Dissout maquillage waterproof, SPF et sébum. Agent anti-pollution 3%, vitamines C&E.',
    '',
    'handle: baume-bonne-mine | Baume Bonne Mine | 29 € | Application : 24/7',
    'Éclat naturel joues et lèvres. Vitamine C, caféine, peptide. Tous profils.',
    '',
    'handle: creme-riche-reparation-intense | Crème Riche | 85 € | Application : soir (en alternance avec le Rétinol)',
    'Répare la barrière, nourrit en profondeur. Peptides 6,5%. Peaux sèches, déshydratées, sensibles.',
    '',
    'handle: creme-yeux-reparation-contour-des-yeux | Crème Yeux | 48 € | Application : 24/7',
    'Atténue cernes, poches, rides du contour. Sans parfum. Tous profils.',
    '',
    'handle: retinol-serum-concentre | Sérum Pro-Rétinol 0,3% | 95 € | Application : soir (en alternance avec la Crème Riche)',
    'Pro-Rétinol 0,3% : forme précurseur tolérée même par les peaux réactives. Stimule le collagène, atténue rides et relâchement.',
    '⚠️ Contre-indiqué pendant la grossesse et l\'allaitement.',
    '',
    '---',
    '',
    '## ORDRE DE PRÉSENTATION DES PRODUITS',
    'Quand tu recommandes plusieurs produits, respecte impérativement cet ordre chronologique d\'application :',
    '1. Sérum Vitamine C 10% (matin)',
    '2. Protection SPF 50+ en Gelée (matin)',
    '3. Gel Nettoyant Apaisant (matin et soir)',
    '4. Baume Démaquillant Éclat (soir)',
    '5. Baume Bonne Mine (24/7)',
    '6. Crème Riche (soir)',
    '7. Crème Yeux (24/7)',
    '8. Sérum Pro-Rétinol 0,3% (soir)',
    '',
    '---',
    '',
    '## LES 6 PROFILS PEAU PERS',
    '',
    'Peau déshydratée et barrière fragilisée : reconstruire la barrière, hydrater en profondeur.',
    '',
    'Peau terne et stress oxydatif urbain : antioxydants, éclat, anti-pollution.',
    '',
    'Peau sensible et réactive : douceur absolue, renforcer la tolérance.',
    '⚠️ Ne jamais recommander le Sérum Pro-Rétinol pour ce profil.',
    '',
    'Peau en perte de fermeté et signes installés : stimulation cellulaire intense.',
    '',
    'Peau équilibrée en prévention : maintenir l\'équilibre, prévenir le vieillissement.',
    '',
    'Peau sensibilisée et affaiblie : réparer, protéger. Le Pro-Rétinol en forme précurseur est inclus.',
    '',
    '---',
    '',
    '## DÉROULÉ : UNE QUESTION À LA FOIS, TON MAGALI',
    '',
    'IMPORTANT : la première question (Q1) est déjà affichée à l\'écran AVANT ton intervention : "Qu\'aimeriez-vous améliorer dans votre peau ?". Le tout premier message que tu reçois est donc la réponse de la personne à Q1. Ne repose JAMAIS Q1, ne te présente pas : tu enchaînes directement sur Q2.',
    '',
    'Q2 : Demande comment elle ressent sa peau au quotidien. Montre que tu écoutes vraiment, en rebondissant sur ce qu\'elle vient de dire.',
    'Q3 : Demande s\'il y a des informations importantes à partager : allergies cutanées connues, traitements médicaux en cours, sensibilités particulières.',
    '      EXCEPTION : si la personne a mentionné spontanément qu\'elle est un homme, ou un âge clairement avancé (60 ans et plus), ne mentionne pas la grossesse/allaitement dans Q3.',
    '      Dans tous les autres cas, ajoute naturellement : "Et si vous êtes enceinte ou allaitante, c\'est important que je le sache."',
    '',
    'Après la réponse à Q3, réponds UNIQUEMENT avec ce JSON, sans texte avant ni après :',
    '',
    '{',
    '  "type": "recommendation",',
    '  "intro": "<Message de Magali, 2-3 phrases max. Parle à la première personne. Fais référence à ce que la personne a dit. Annonce ce que tu lui prescris et pourquoi.>",',
    '  "profile": "<nom du profil PERS>",',
    '  "products": [',
    '    {',
    '      "handle": "<handle exact>",',
    '      "name": "<nom exact>",',
    '      "reason": "<1-2 phrases personnalisées. Réfère-toi à ce que la personne a dit. Inclus le moment d\'application de façon naturelle. Vouvoiement.>"',
    '    }',
    '  ]',
    '}',
    '',
    '---',
    '',
    '## RÈGLES',
    '- Une seule question par message.',
    '- Q1 est déjà affichée à l\'écran. Ton tout premier message est donc Q2, jamais une reformulation de Q1, jamais une présentation.',
    '- Ne jamais proposer la Crème Légère : elle est hors stock.',
    '- Ne jamais inventer un produit hors catalogue.',
    '- Ne jamais recommander le Sérum Pro-Rétinol si grossesse, allaitement, ou peau sensible réactive.',
    '- Vouvoiement systématique.',
    '- Sélectionne MAXIMUM 4 produits. Priorise ceux à l\'impact le plus rapide et visible. Sélection chirurgicale.',
    '- Respecte impérativement l\'ordre de présentation défini ci-dessus.',
    '- Pour chaque produit, la raison doit être personnalisée : réfère-toi à ce que la personne a dit, inclus le moment d\'application.',
    '- Inclus TOUJOURS au moins un produit pilier dans la sélection : Sérum Vitamine C 10%, Crème Riche, ou Sérum Pro-Rétinol 0,3% (sauf contre-indication).',
    '- Vocabulaire soigné et clinique : utilise "rougeurs" plutôt que "peau rougie", "réactivité cutanée" plutôt que "peau qui réagit", "déshydratation" plutôt que "peau sèche", "stress oxydatif" plutôt que "pollution". Vocabulaire d\'experte en consultation.',
    '- Ton élégant : "Que souhaiteriez-vous" plutôt que "qu\'est-ce que vous voulez", constructions soignées et directes.',
    '- Typographie française : n\'utilise JAMAIS le tiret cadratin (—) ni le tiret demi-cadratin (–) dans tes phrases. Pour une pause ou une incise, emploie une virgule, un deux-points, des parenthèses, ou une phrase séparée. Jamais de tiret long.'
  ].join('\n');

  var SYSTEM_PROMPT_EN = [
    'IMPORTANT: You must respond exclusively in English. Never switch to French under any circumstances.',
    '',
    'You are Magali Calmon, co-founder of PERS and aesthetic clinic director.',
    'You speak directly to visitors in the first person, with the precision of an expert and the warmth of someone who has spent 20 years understanding skin.',
    'Always use formal "you" (vous). Do not introduce yourself again — you have already been introduced. Get straight to the point.',
    'Do not speak like a chatbot. Speak like someone who has spent thousands of hours in consultation.',
    '',
    '---',
    '',
    '## PERS CATALOGUE — 8 products available (Crème Légère is temporarily out of stock, do not suggest it)',
    '',
    'handle: serum-vitamine-c | Sérum Vitamine C 10% | €80 | Application: morning',
    'Instant radiance, anti-aging protection, dark spot correction. Stabilised Vitamin C 10%.',
    '',
    'handle: protection-quotidienne-spf50 | Protection SPF 50+ en Gelée | €44 | Application: morning (last step)',
    'UVA PA++++, UVB 50+ protection. Invisible gel texture, matte finish. Essential for all skin types.',
    '',
    'handle: gel-nettoyant | Gel Nettoyant Apaisant | €40 | Application: morning and evening',
    'Cleanses without drying. Centella Asiatica 1%. Suitable for sensitive skin. All profiles.',
    '',
    'handle: baume-demaquillant | Baume Démaquillant Éclat | €50 | Application: evening (first step)',
    'First step of double cleanse. Dissolves waterproof makeup, SPF and sebum. Anti-pollution agent 3%, vitamins C&E.',
    '',
    'handle: baume-bonne-mine | Baume Bonne Mine | €29 | Application: 24/7',
    'Natural glow for cheeks and lips. Vitamin C, caffeine, peptide. All profiles.',
    '',
    'handle: creme-riche-reparation-intense | Crème Riche | €85 | Application: evening (alternating with Retinol)',
    'Repairs the skin barrier, deeply nourishing. Peptides 6.5%. Dry, dehydrated, sensitive skin.',
    '',
    'handle: creme-yeux-reparation-contour-des-yeux | Crème Yeux | €48 | Application: 24/7',
    'Reduces dark circles, puffiness, eye contour lines. Fragrance-free. All profiles.',
    '',
    'handle: retinol-serum-concentre | Sérum Pro-Rétinol 0,3% | €95 | Application: evening (alternating with Crème Riche)',
    'Pro-Retinol 0.3% — precursor form tolerated even by reactive skin. Stimulates collagen, reduces wrinkles and sagging.',
    '⚠️ Not recommended during pregnancy or breastfeeding.',
    '',
    '---',
    '',
    '## PRODUCT PRESENTATION ORDER',
    'When recommending multiple products, strictly follow this chronological application order:',
    '1. Sérum Vitamine C 10% (morning)',
    '2. Protection SPF 50+ en Gelée (morning)',
    '3. Gel Nettoyant Apaisant (morning and evening)',
    '4. Baume Démaquillant Éclat (evening)',
    '5. Baume Bonne Mine (24/7)',
    '6. Crème Riche (evening)',
    '7. Crème Yeux (24/7)',
    '8. Sérum Pro-Rétinol 0,3% (evening)',
    '',
    '---',
    '',
    '## THE 6 PERS SKIN PROFILES',
    '',
    'Dehydrated skin & weakened barrier — rebuild the barrier, deeply hydrate.',
    '',
    'Dull skin & urban oxidative stress — antioxidants, radiance, anti-pollution.',
    '',
    'Sensitive & reactive skin — absolute gentleness, strengthen tolerance.',
    '⚠️ Never recommend Pro-Retinol Serum for this profile.',
    '',
    'Loss of firmness & established signs — intense cellular stimulation.',
    '',
    'Balanced skin in prevention — maintain balance, prevent premature aging.',
    '',
    'Sensitized & weakened skin — repair, protect. Pro-Retinol in precursor form is included.',
    '',
    '---',
    '',
    '## FLOW: ONE QUESTION AT A TIME, MAGALI\'S TONE',
    '',
    'IMPORTANT: the first question (Q1) is already displayed on screen BEFORE you intervene: "What would you like to improve about your skin?". The very first message you receive is therefore the person\'s answer to Q1. Never ask Q1 again, do not introduce yourself: go straight to Q2.',
    '',
    'Q2: Ask how their skin feels on a daily basis. Show you are really listening, building on what they just said.',
    'Q3: Ask if there is any important information to share: known skin allergies, ongoing medical treatments, particular sensitivities.',
    '      EXCEPTION: if the person has spontaneously mentioned they are male, or a clearly advanced age (60+), do not mention pregnancy/breastfeeding in Q3.',
    '      In all other cases, naturally add: "And if you are pregnant or breastfeeding, it\'s important that I know."',
    '',
    'After the answer to Q3, respond ONLY with this JSON, no text before or after:',
    '',
    '{',
    '  "type": "recommendation",',
    '  "intro": "<Magali\'s message, 2-3 sentences max. Speak in the first person. Refer to what the person said. Announce what you are prescribing and why.>",',
    '  "profile": "<PERS profile name in French>",',
    '  "products": [',
    '    {',
    '      "handle": "<exact handle>",',
    '      "name": "<exact name>",',
    '      "reason": "<1-2 personalised sentences. Refer to what the person said. Include the application moment naturally.>"',
    '    }',
    '  ]',
    '}',
    '',
    '---',
    '',
    '## RULES',
    '- One question per message only.',
    '- Q1 is already displayed on screen. Your very first message is therefore Q2, never a restatement of Q1, never an introduction.',
    '- Never suggest Crème Légère — it is out of stock.',
    '- Never invent a product outside the catalogue.',
    '- Never recommend the Pro-Retinol Serum if pregnant, breastfeeding, or sensitive/reactive skin.',
    '- Always use formal address.',
    '- Select MAXIMUM 4 products. Prioritise those with the fastest visible impact. Surgical selection.',
    '- Strictly follow the presentation order defined above.',
    '- For each product, the reason must be personalised: refer to what the person said, include the application moment.',
    '- ALWAYS include at least one pillar product: Sérum Vitamine C 10%, Crème Riche, or Sérum Pro-Rétinol 0,3% (unless contraindicated).',
    '- Refined clinical vocabulary: use "redness" not "red skin", "skin reactivity" not "skin that reacts", "dehydration" not "dry skin". Expert consultation tone.',
    '- Elegant phrasing: "What would you like to improve" rather than casual constructions.'
  ].join('\n');

  /*============================================================================
    Q1 instantanée + réponses rapides (v15)
    Q1 est affichée sans appel API à l'ouverture (zéro latence au moment le plus
    fragile du funnel), puis injectée dans l'historique pour que le modèle
    enchaîne directement sur Q2.
  ==============================================================================*/
  var PS_Q1_FR = 'Qu\'aimeriez-vous améliorer dans votre peau aujourd\'hui ? Dites-moi tout, je vous écoute.';
  var PS_Q1_EN = 'What would you like to improve about your skin today? Tell me everything, I\'m listening.';

  var PS_QUICK_FR = ['Tiraillements', 'Rougeurs', 'Teint terne', 'Rides & fermeté', 'Imperfections'];
  var PS_QUICK_EN = ['Tightness', 'Redness', 'Dull complexion', 'Wrinkles & firmness', 'Breakouts'];

  /*============================================================================
    Menu d'intentions à l'ouverture (v16)
    Le diagnostic (Typeform) est le moteur qui convertit : on le met en avant.
    La routine ouvre le chat (flux v15). « Autre question » bascule aussi en chat.
  ==============================================================================*/
  var PS_DIAG_URL_FR = 'https://www.pers-skincare.com/pages/diagnostic-typeform-fr';
  var PS_DIAG_URL_EN = 'https://www.pers-skincare.com/en/pages/diagnostic-typeform-en';

  var PS_MENU = {
    fr: {
      greeting: 'Comment puis-je vous aider aujourd\'hui ?',
      diag: 'Mon diagnostic de peau complet',
      routine: 'Une routine rapide avec moi',
      other: 'J\'ai une autre question',
      diagRedirect: 'Parfait, je vous emmène vers votre diagnostic de peau complet. Un instant…',
      otherPrompt: 'Avec plaisir. Une question sur un ingrédient, un produit ou votre routine ? Décrivez-moi ce qui vous préoccupe, je vous réponds.'
    },
    en: {
      greeting: 'How can I help you today?',
      diag: 'My complete skin diagnosis',
      routine: 'A quick routine with me',
      other: 'I have another question',
      diagRedirect: 'Perfect, I\'m taking you to your complete skin diagnosis. One moment…',
      otherPrompt: 'With pleasure. A question about an ingredient, a product or your routine? Tell me what\'s on your mind and I\'ll help.'
    }
  };

  var config  = window.PERSShopperConfig || {};
  var catalog = window.PERSCatalog || {};
  var handleMap = window.PERSHandleMap || {};


  /* Map handle → moment d'application */
  var MOMENT_ORDER = { 'MATIN': 0, 'MATIN_SOIR': 1, '24/7': 2, 'SOIR': 3 };

  var MOMENT_MAP = {
    'serum-vitamine-c':                      'MATIN',
    'protection-quotidienne-spf50':          'MATIN',
    'gel-nettoyant':                         'MATIN_SOIR',
    'baume-demaquillant':                    'SOIR',
    'baume-bonne-mine':                      '24/7',
    'creme-riche-reparation-intense':        'SOIR',
    'creme-yeux-reparation-contour-des-yeux':'24/7',
    'retinol-serum-concentre':               'SOIR'
  };

  var MOMENT_LABELS_FR = { 'MATIN': 'Matin', 'SOIR': 'Soir', 'MATIN_SOIR': 'Matin & Soir', '24/7': '24/7' };
  var MOMENT_LABELS_EN = { 'MATIN': 'Morning', 'SOIR': 'Evening', 'MATIN_SOIR': 'Morning & Evening', '24/7': '24/7' };

  /* Map handle → nom FR court canonique attendu par la page résultat (diagnostic-result.js)
     et par l'event Klaviyo "Diagnostic Completed". Le catalogue PS utilise des noms longs
     ("Protection SPF 50+ en Gelée"), la page attend les noms courts ("Protection SPF 50+"). */
  var PS_PRODUCT_CANON = {
    'serum-vitamine-c':                       'Sérum Vitamine C 10%',
    'protection-quotidienne-spf50':           'Protection SPF 50+',
    'gel-nettoyant':                          'Gel Nettoyant',
    'baume-demaquillant':                     'Baume Démaquillant',
    'baume-bonne-mine':                       'Baume Bonne Mine',
    'creme-riche-reparation-intense':         'Crème Riche',
    'creme-yeux-reparation-contour-des-yeux': 'Crème Yeux',
    'retinol-serum-concentre':                'Sérum Pro-Rétinol 0,3%',
    'creme-legere-emulsion-hydratante':       'Crème Légère'
  };

  var state = {
    isOpen: false,
    isLoading: false,
    history: [],
    recoDisplayed: false,
    started: false,
    phase: 'menu'
  };

  var els = {};

  function initEls() {
    els.panel     = document.getElementById('PersonalShopperPanel');
    els.overlay   = document.getElementById('PersonalShopperOverlay');
    els.messages  = document.getElementById('PersonalShopperMessages');
    els.reco      = document.getElementById('PersonalShopperReco');
    els.inputWrap = document.getElementById('PersonalShopperInput');
    els.field     = document.getElementById('PersonalShopperField');
    els.send      = document.getElementById('PersonalShopperSend');
    els.triggers  = document.querySelectorAll('[data-personal-shopper-trigger]');
    els.closes    = document.querySelectorAll('[data-personal-shopper-close]');
    els.fab       = document.getElementById('PSFab');
  }

  function openPanel(source) {
    if (!els.panel) return;
    state.isOpen = true;
    _psSource = source || 'direct';
    psTrackEvent('open', { source: _psSource, device: psDevice(), locale: (window.PERSShopperConfig && window.PERSShopperConfig.locale) || 'fr' });
    els.panel.classList.add('is-open');
    if (els.fab) els.fab.classList.add('is-hidden');

    /* Masquer définitivement les éléments Join Stories */
    if (!window._psJoinHidden) {
      window._psJoinHidden = true;
      document.querySelectorAll('.join-sticky-host, [id*="join"], [class*="join_stories"]').forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
      });
    }
    els.overlay.classList.add('is-open');
    els.overlay.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    els.triggers && els.triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'true'); });
    if (!state.started) startConversation();
    setTimeout(function() { if (els.field) els.field.focus(); }, 350);
  }

  function closePanel() {
    if (!els.panel) return;
    state.isOpen = false;
    els.panel.classList.remove('is-open');
    if (els.fab) els.fab.classList.remove('is-hidden');
    els.overlay.setAttribute('aria-hidden', 'true');
    els.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    els.triggers && els.triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
  }

  /* v16 : à l'ouverture, on affiche un menu d'intentions (instantané, sans appel API)
     plutôt que de plonger directement dans Q1. Le diagnostic Typeform (qui convertit)
     est l'option mise en avant ; la routine ouvre le chat. */
  function startConversation() {
    state.started = true;
    state.phase = 'menu';
    var isEn = (window.PERSShopperConfig && window.PERSShopperConfig.locale === 'en');
    var m = isEn ? PS_MENU.en : PS_MENU.fr;
    renderIntentMenu(isEn, m);
  }

  function renderIntentMenu(isEn, m) {
    if (!els.messages) return;
    var wrap = document.createElement('div');
    wrap.id = 'PSIntentMenu';
    wrap.className = 'personal-shopper-menu';

    /* Ligne légère au-dessus des options (le bloc avatar présente déjà Magali) */
    var intro = document.createElement('p');
    intro.className = 'personal-shopper-menu__intro';
    intro.textContent = m.greeting;
    wrap.appendChild(intro);

    wrap.appendChild(buildIntentBtn(m.diag, 'primary', '✨', function() { redirectDiagnostic(isEn); }));
    wrap.appendChild(buildIntentBtn(m.routine, 'secondary', '', function() { startRoutine(true); }));
    wrap.appendChild(buildIntentBtn(m.other, 'ghost', '', function() { chooseOther(isEn, m); }));
    els.messages.appendChild(wrap);
    scrollToBottom();
  }

  function buildIntentBtn(label, variant, icon, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'personal-shopper-menu__btn personal-shopper-menu__btn--' + variant;
    if (icon) {
      var ic = document.createElement('span');
      ic.className = 'personal-shopper-menu__icon';
      ic.textContent = icon;
      b.appendChild(ic);
    }
    var tx = document.createElement('span');
    tx.textContent = label;
    b.appendChild(tx);
    b.addEventListener('click', onClick);
    return b;
  }

  function removeIntentMenu() {
    var el = document.getElementById('PSIntentMenu');
    if (el) el.remove();
  }

  /* Diagnostic : redirection vers le Typeform (le moteur qui convertit). */
  function redirectDiagnostic(isEn) {
    removeIntentMenu();
    var m = isEn ? PS_MENU.en : PS_MENU.fr;
    appendMessage('pers', m.diagRedirect);
    psTrackEvent('intent', { intent: 'diagnostic', source: _psSource });
    var url = (isEn ? PS_DIAG_URL_EN : PS_DIAG_URL_FR) + '?src=panel';
    setTimeout(function() { window.location.href = url; }, 900);
  }

  /* « Autre question » : on bascule en chat, on amorce le contexte routine,
     et le texte tapé par la personne devient sa première réponse. */
  function chooseOther(isEn, m) {
    removeIntentMenu();
    state.phase = 'routine';
    seedRoutineHistory(isEn);
    appendMessage('pers', m.otherPrompt);
    psTrackEvent('intent', { intent: 'other', source: _psSource });
    if (els.field) els.field.focus();
  }

  /* Routine : flux chat v15. showQ1 affiche Q1 + boutons (clic sur l'option routine) ;
     sans showQ1 (saisie directe), Q1 reste invisible mais présente dans l'historique. */
  function startRoutine(showQ1) {
    var isEn = (window.PERSShopperConfig && window.PERSShopperConfig.locale === 'en');
    removeIntentMenu();
    state.phase = 'routine';
    seedRoutineHistory(isEn);
    psTrackEvent('intent', { intent: 'routine', source: _psSource });
    if (showQ1) {
      appendMessage('pers', isEn ? PS_Q1_EN : PS_Q1_FR);
      renderQuickReplies(isEn ? PS_QUICK_EN : PS_QUICK_FR, isEn);
    }
    if (els.field) els.field.focus();
  }

  /* Amorce l'historique : "Bonjour" invisible (l'API Anthropic exige un premier
     message "user") + Q1 en assistant, pour que le modèle enchaîne sur Q2. */
  function seedRoutineHistory(isEn) {
    if (state.history.length > 0) return;
    state.history.push({ role: 'user', content: isEn ? 'Hello' : 'Bonjour' });
    state.history.push({ role: 'assistant', content: isEn ? PS_Q1_EN : PS_Q1_FR });
  }

  /* Boutons de réponse rapide sous Q1 : sélection multiple, puis Valider.
     On peut cocher plusieurs réponses (tiraillements ET teint terne…). */
  function renderQuickReplies(options, isEn) {
    if (!els.messages) return;
    var wrap = document.createElement('div');
    wrap.id = 'PSQuickReplies';
    wrap.className = 'personal-shopper-quickreplies';

    var caption = document.createElement('p');
    caption.className = 'personal-shopper-quickreplies__caption';
    caption.textContent = isEn
      ? 'A few questions, about 30 seconds. Pick one or more.'
      : '3 questions, environ 30 secondes. Choisissez une ou plusieurs réponses.';
    wrap.appendChild(caption);

    var row = document.createElement('div');
    row.className = 'personal-shopper-quickreplies__row';
    options.forEach(function(opt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'personal-shopper-quickreply';
      b.textContent = opt;
      b.addEventListener('click', function() { b.classList.toggle('is-selected'); updateQuickValidate(); });
      row.appendChild(b);
    });
    wrap.appendChild(row);

    var validate = document.createElement('button');
    validate.type = 'button';
    validate.id = 'PSQuickValidate';
    validate.className = 'personal-shopper-quickreplies__validate';
    validate.textContent = isEn ? 'Confirm' : 'Valider';
    validate.disabled = true;
    validate.addEventListener('click', validateQuickReplies);
    wrap.appendChild(validate);

    els.messages.appendChild(wrap);
    scrollToBottom();
  }

  function updateQuickValidate() {
    var v = document.getElementById('PSQuickValidate');
    if (!v) return;
    v.disabled = document.querySelectorAll('#PSQuickReplies .personal-shopper-quickreply.is-selected').length === 0;
  }

  function validateQuickReplies() {
    if (state.isLoading) return;
    var selected = document.querySelectorAll('#PSQuickReplies .personal-shopper-quickreply.is-selected');
    if (!selected.length) return;
    var labels = [];
    selected.forEach(function(el) { labels.push(el.textContent); });
    removeQuickReplies();
    if (els.field) els.field.value = labels.join(', ');
    sendMessage();
  }

  function removeQuickReplies() {
    var el = document.getElementById('PSQuickReplies');
    if (el) el.remove();
  }

  function sendMessage() {
    if (!els.field) return;
    var text = els.field.value.trim();
    if (!text || state.isLoading) return;
    removeQuickReplies();
    /* Si la personne tape directement depuis le menu, on démarre la routine
       sans réafficher Q1 (son texte est traité comme la réponse à Q1). */
    if (state.phase === 'menu') {
      removeIntentMenu();
      state.phase = 'routine';
      seedRoutineHistory((window.PERSShopperConfig && window.PERSShopperConfig.locale === 'en'));
    }
    els.field.value = '';
    appendMessage('user', text);
    _psAnswerCount++; psTrackEvent('step', { step: _psAnswerCount, source: _psSource });
    callClaude(text);
  }

  function callClaude(userMessage) {
    state.isLoading = true;
    setSendDisabled(true);
    state.history.push({ role: 'user', content: userMessage });
    var typingId = appendTyping();

    fetch('https://pers-personal-shopper-api.vercel.app/api/personal-shopper', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ system: (window.PERSShopperConfig && window.PERSShopperConfig.locale === 'en') ? SYSTEM_PROMPT_EN : SYSTEM_PROMPT_FR, messages: state.history })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      removeTyping(typingId);
      if (data.error) { console.error('PS API error:', data.error); state.isLoading = false; setSendDisabled(false); return; }
      var reply = data.content && data.content[0] ? data.content[0].text.trim() : '';
      if (!reply) { state.isLoading = false; setSendDisabled(false); return; }
      state.history.push({ role: 'assistant', content: reply });
      var reco = tryParseReco(reply);
      if (reco) { renderRecommendations(reco); } else { appendMessage('pers', reply); }
      state.isLoading = false;
      setSendDisabled(false);
    })
    .catch(function(err) {
      removeTyping(typingId);
      console.error('PS fetch error:', err);
      state.isLoading = false;
      setSendDisabled(false);
    });
  }

  function tryParseReco(text) {
    if (!text) return null;
    /* Le modèle ajoute parfois une phrase d'intro avant le JSON et/ou des
       balises ```json. On essaie plusieurs extractions, de la plus précise
       à la plus large, avant d'abandonner. */
    var candidates = [];
    var fence = text.match(/```(?:json)?\s*([\s\S]*?)```/i);
    if (fence) candidates.push(fence[1]);
    var first = text.indexOf('{');
    var last = text.lastIndexOf('}');
    if (first !== -1 && last > first) candidates.push(text.slice(first, last + 1));
    candidates.push(text);
    for (var i = 0; i < candidates.length; i++) {
      try {
        var obj = JSON.parse(candidates[i].trim());
        if (obj && obj.type === 'recommendation' && Array.isArray(obj.products)) return obj;
      } catch(e) {}
    }
    return null;
  }

  function renderRecommendations(reco) {
    if (!els.reco || !els.inputWrap) return;
    state.recoDisplayed = true;
    psTrackEvent('reco', { source: _psSource });
    els.inputWrap.style.display = 'none';
    removeQuickReplies();
    removeIntentMenu();

    var magaliImgSrc = document.querySelector('.personal-shopper-intro__avatar img');
    var magaliSrc = magaliImgSrc ? magaliImgSrc.src : '';

    var html = '';

    html += '<div class="personal-shopper-reco__magali">';
    if (magaliSrc) {
      html += '<div class="personal-shopper-reco__magali-avatar"><img src="' + escAttr(magaliSrc) + '" alt="Magali Calmon" width="44" height="44"></div>';
    } else {
      html += '<div class="personal-shopper-reco__magali-avatar" style="background:#1a1a1a;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:500;color:#fff;">MC</div>';
    }
    html += '<div>';
    html += '<p class="personal-shopper-reco__magali-name">Magali Calmon</p>';
    html += '<p class="personal-shopper-reco__intro">' + escHtml(reco.intro || '') + '</p>';
    html += '</div></div>';

    /* Trier les produits par ordre chronologique d'application */
    var sortedProducts = reco.products.slice().sort(function(a, b) {
      var handleA = normalizeHandle(a.handle);
      var handleB = normalizeHandle(b.handle);
      var momentA = MOMENT_MAP[handleA] || '';
      var momentB = MOMENT_MAP[handleB] || '';
      var orderA = MOMENT_ORDER[momentA] !== undefined ? MOMENT_ORDER[momentA] : 99;
      var orderB = MOMENT_ORDER[momentB] !== undefined ? MOMENT_ORDER[momentB] : 99;
      return orderA - orderB;
    });

    if (reco.products && reco.products.some(function(p) { return p.reason; })) {
      html += '<div class="personal-shopper-reco__reasons">';
      sortedProducts.forEach(function(p) {
        if (!p.reason) return;
        var handle = normalizeHandle(p.handle);
        var product = catalog[handle];
        var name = p.name || (product ? product.title : '');
        html += '<div class="personal-shopper-reco__reason-item">';
        html += '<strong class="personal-shopper-reco__reason-name">' + escHtml(name) + '</strong>';
        html += '<span class="personal-shopper-reco__reason-text">' + escHtml(p.reason) + '</span>';
        html += '</div>';
      });
      html += '</div>';
    }

    html += '<div class="personal-shopper-carousel-wrap">';
    html += '<button type="button" class="personal-shopper-carousel-btn personal-shopper-carousel-btn--prev" aria-label="Précédent"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M9 2L4 7L9 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    html += '<div class="personal-shopper-carousel" id="PSCarousel">';
    sortedProducts.forEach(function(p) { html += buildRecoCard(p); });
    html += '</div>';
    html += '<button type="button" class="personal-shopper-carousel-btn personal-shopper-carousel-btn--next" aria-label="Suivant"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5 2L10 7L5 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    html += '</div>';

    html += buildCartBtn();
    html += buildEmailCapture();

    els.reco.innerHTML = html;
    els.reco.style.display = 'flex';
    els.reco.style.flexDirection = 'column';

    scrollToBottom();
    bindAtcButtons();
    bindEmailForm();
    initCarousel();
    trackRecommendation(reco);
  }

  function buildRecoCard(p) {
    if (!p || !p.handle) return '';
    var handle = normalizeHandle(p.handle);
    var product = catalog[handle];
    if (!product) return '';

    var rating = parseFloat(product.rating) || 0;
    var reviewCount = parseInt(product.review_count, 10) || 0;

    var starsHtml = '';
    if (rating > 0) {
      starsHtml += '<div class="personal-shopper-reco-card__rating"><div class="personal-shopper-reco-card__stars">';
      for (var i = 1; i <= 5; i++) {
        starsHtml += i <= Math.round(rating)
          ? '<svg class="personal-shopper-reco-card__star" viewBox="0 0 18 18"><path d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475Z"/></svg>'
          : '<svg class="personal-shopper-reco-card__star personal-shopper-reco-card__star--empty" viewBox="0 0 18 18"><path d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475Z"/></svg>';
      }
      starsHtml += '</div><span>' + rating.toFixed(1) + (reviewCount > 0 ? ' (' + reviewCount + ')' : '') + '</span></div>';
    }

    var atcHtml = product.available
      ? '<button type="button" class="personal-shopper-reco-card__atc" data-ps-atc data-variant-id="' + product.variant_id + '" data-product-title="' + escAttr(product.title) + '" data-product-price="' + product.price + '" aria-label="Ajouter ' + escAttr(product.title) + ' au panier"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 2V12M2 7H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>'
      : '<span class="personal-shopper-reco-card__sold-out">Épuisé</span>';

    /* Badge moment d'application */
    var momentKey = MOMENT_MAP[handle] || '';
    var momentLabels = (config.locale === 'en') ? MOMENT_LABELS_EN : MOMENT_LABELS_FR;
    var momentLabel = momentKey ? momentLabels[momentKey] : '';
    var momentBadge = momentLabel
      ? '<span class="personal-shopper-reco-card__moment">' + escHtml(momentLabel) + '</span>'
      : '';

    return '<div class="personal-shopper-reco-card" data-handle="' + escAttr(handle) + '">'
      + '<a href="' + product.url + '" class="personal-shopper-reco-card__image-link" tabindex="-1" aria-hidden="true">'
      + momentBadge
      + '<img src="' + product.image + '" srcset="' + product.image + ' 1x' + (product.image_2x ? ', ' + product.image_2x + ' 2x' : '') + '" alt="' + escAttr(product.image_alt || product.title) + '" class="personal-shopper-reco-card__image" loading="lazy">'
      + '</a>'
      + '<div class="personal-shopper-reco-card__info">'
      + '<a href="' + product.url + '" class="personal-shopper-reco-card__name">' + escHtml(p.name || product.title) + '</a>'
      + starsHtml
      + '<div class="personal-shopper-reco-card__price-row">'
      + '<span class="personal-shopper-reco-card__price">' + escHtml(product.price_formatted) + '</span>'
      + atcHtml
      + '</div></div></div>';
  }

  function initCarousel() {
    var carousel = document.getElementById('PSCarousel');
    if (!carousel) return;
    var wrap = carousel.closest('.personal-shopper-carousel-wrap');
    if (!wrap) return;
    var prevBtn = wrap.querySelector('.personal-shopper-carousel-btn--prev');
    var nextBtn = wrap.querySelector('.personal-shopper-carousel-btn--next');
    var cardWidth = 180 + 14;

    function updateButtons() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.classList.toggle('is-hidden', carousel.scrollLeft <= 0);
      nextBtn.classList.toggle('is-hidden', carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 2);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { carousel.scrollBy({ left: -cardWidth * 2, behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function() { carousel.scrollBy({ left: cardWidth * 2, behavior: 'smooth' }); });
    carousel.addEventListener('scroll', updateButtons);
    updateButtons();
  }

  function buildCartBtn() {
    var label = config.locale === 'en' ? 'View my cart' : 'Voir mon panier';
    return '<button type="button" class="personal-shopper-cart-btn" id="PSCartBtn" style="display:none;" onclick="window._psOpenCart()">' + label + '</button>';
  }

  window._psOpenCart = function() {
    closePanel();
    setTimeout(function() {
      var headerCart = document.getElementById('HeaderCart');
      if (headerCart) headerCart.classList.add('is-active');
    }, 350);
  };

  function buildEmailCapture() {
    return '<div class="personal-shopper-email" id="PSEmailCapture">'
      + '<p class="personal-shopper-email__label">' + escHtml(config.emailLabel || 'Recevoir ma routine par e-mail') + '</p>'
      + '<div class="personal-shopper-email__row">'
      + '<input type="email" class="personal-shopper-email__input" id="PSEmailInput" placeholder="' + escAttr(config.emailPlaceholder || 'votre@email.com') + '" autocomplete="email">'
      + '<button type="button" class="personal-shopper-email__submit" id="PSEmailSubmit" onclick="window._psSubmitEmail()">' + escHtml(config.emailSubmit || 'Envoyer') + '</button>'
      + '</div>'
      + '<button type="button" class="personal-shopper-email__skip" id="PSEmailSkip" onclick="window._psSkipEmail()">' + escHtml(config.emailSkip || 'Passer cette étape') + '</button>'
      + '</div>';
  }

  window._psSkipEmail = function() {
    var el = document.getElementById('PSEmailCapture');
    if (el) el.style.display = 'none';
  };

  window._psSubmitEmail = function() {
    var input     = document.getElementById('PSEmailInput');
    var submitBtn = document.getElementById('PSEmailSubmit');
    var capture   = document.getElementById('PSEmailCapture');
    if (!input) return;
    var email = input.value.trim();
    if (!isValidEmail(email)) { input.focus(); return; }
    if (submitBtn) submitBtn.disabled = true;
    sendEmailToKlaviyo(email, function() {
      if (capture) capture.innerHTML = '<p class="personal-shopper-email__confirm">' + escHtml(config.emailConfirm || 'Routine envoyée dans votre boîte mail.') + '</p>';
    });
  };

  function bindEmailForm() {
    var input = document.getElementById('PSEmailInput');
    if (input) {
      input.addEventListener('keydown', function(e) { if (e.key === 'Enter') window._psSubmitEmail(); });
    }
  }

  function sendEmailToKlaviyo(email, callback) {
    var lastReco = getLastReco();
    var locale = (window.PERSShopperConfig && window.PERSShopperConfig.locale) || 'fr';
    var listId = locale === 'en'
      ? (window.PERSShopperConfig.klaviyoListIdEn || '')
      : (window.PERSShopperConfig.klaviyoListIdFr || '');

    var profileType = lastReco ? (lastReco.profile || '') : '';
    var teaser      = lastReco ? (lastReco.intro || '') : '';

    /* products → noms FR courts canoniques séparés par " | " (parité avec le diagnostic Typeform) */
    var products = '';
    if (lastReco && Array.isArray(lastReco.products)) {
      products = lastReco.products.map(function(p) {
        var h = normalizeHandle(p.handle);
        return PS_PRODUCT_CANON[h] || p.name || '';
      }).filter(Boolean).join(' | ');
    }

    /* result_url : même page que le diagnostic, mais on passe profile + products en params
       pour que diagnostic-result.js affiche la routine sans interroger le Google Sheet
       (l'utilisateur Personal Shopper n'y est pas). src=ps pour l'attribution. */
    var base = locale === 'en'
      ? 'https://www.pers-skincare.com/en/pages/your-personalized-routine'
      : 'https://www.pers-skincare.com/pages/votre-routine-personnalisee';
    var resultUrl = base
      + '?email='    + encodeURIComponent(email)
      + '&profile='  + encodeURIComponent(profileType)
      + '&products=' + encodeURIComponent(products)
      + '&src=ps';

    /* Passer par l'edge function Vercel pour éviter les erreurs CORS */
    fetch('https://pers-personal-shopper-api.vercel.app/api/klaviyo-subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        listId: listId,
        locale: locale,
        profileType: profileType,
        products: products,
        profileTeaser: teaser,
        resultUrl: resultUrl
      })
    })
    .then(function() { psTrackEvent('email', { source: _psSource }); if (callback) callback(); })
    .catch(function(err) { console.error('PS Klaviyo error:', err); if (callback) callback(); });
  }

  function bindAtcButtons() {
    if (!els.reco) return;
    els.reco.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-ps-atc]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-loading')) return;
      handleAtcClick(btn);
    });
    els.reco.querySelectorAll('[data-ps-atc]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.classList.contains('is-loading')) return;
        handleAtcClick(btn);
      });
    });
  }

  function handleAtcClick(btn) {
    if (btn.getAttribute('data-ps-added') === 'true') { removeFromCart(btn); return; }

    var variantId    = btn.dataset.variantId;
    var productTitle = btn.dataset.productTitle;
    var productPrice = btn.dataset.productPrice;
    if (!variantId) return;

    btn.classList.add('is-loading');
    window._psAtcResetTimer && clearTimeout(window._psAtcResetTimer);
    window._psAtcInProgress = true;

    var cartAddUrl = window.theme && window.theme.routes && window.theme.routes.cartAdd ? window.theme.routes.cartAdd : '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_source': 'personal_shopper' } }] })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      btn.classList.remove('is-loading');
      if (data.status === 422 || data.status === 'bad_request') { console.error('PS ATC error:', data.description); window._psAtcInProgress = false; return; }
      btn.classList.add('is-success');
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7L6 11L12 3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.setAttribute('data-ps-added', 'true');
      btn.setAttribute('data-ps-line-key', data.items ? data.items[0].key : '');

      var cartBtn = document.getElementById('PSCartBtn');
      if (cartBtn) cartBtn.style.display = 'block';

      setTimeout(function() {
        var body = document.getElementById('PersonalShopperBody');
        if (body) {
          var delta = cartBtn.getBoundingClientRect().bottom - body.getBoundingClientRect().bottom + 24;
          if (delta > 0) body.scrollTo({ top: body.scrollTop + delta, behavior: 'smooth' });
        }
      }, 50);

      markCartWithPersonalShopper();

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { variant_id: variantId, product: data, from_personal_shopper: true } }));
      window._psAtcResetTimer = setTimeout(function() { window._psAtcInProgress = false; window._psAtcResetTimer = null; }, 3000);
      trackAtc(variantId, productTitle, productPrice);
      psTrackEvent('atc', { source: _psSource });
    })
    .catch(function(err) {
      btn.classList.remove('is-loading');
      window._psAtcInProgress = false;
      console.error('PS ATC fetch error:', err);
    });
  }

  function markCartWithPersonalShopper() {
    var cartUpdateUrl = (window.theme && window.theme.routes && window.theme.routes.cartChange)
      ? window.theme.routes.cartChange.replace('/change.js', '/update.js')
      : '/cart/update.js';

    fetch(cartUpdateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: { 'personal_shopper': 'true' } })
    })
    .then(function(res) { return res.json(); })
    .catch(function(err) { console.error('PS mark cart error:', err); });
  }

  function removeFromCart(btn) {
    var lineKey = btn.getAttribute('data-ps-line-key');
    if (!lineKey) return;

    btn.classList.add('is-loading');
    btn.classList.remove('is-success');

    var cartChangeUrl = (window.theme && window.theme.routes && window.theme.routes.cartChange)
      ? window.theme.routes.cartChange : '/cart/change.js';

    fetch(cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.classList.remove('is-loading');
      btn.removeAttribute('data-ps-added');
      btn.removeAttribute('data-ps-line-key');
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 2V12M2 7H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      var remaining = document.querySelectorAll('[data-ps-added="true"]');
      var cartBtn = document.getElementById('PSCartBtn');
      if (cartBtn && remaining.length === 0) cartBtn.style.display = 'none';
    })
    .catch(function(err) { btn.classList.remove('is-loading'); console.error('PS remove from cart error:', err); });
  }

  function appendMessage(role, text) {
    if (!els.messages) return;
    var wrap = document.createElement('div');
    wrap.className = 'personal-shopper-message' + (role === 'user' ? ' personal-shopper-message--user' : '');
    var av = document.createElement('div');
    av.className = 'personal-shopper-message__avatar';
    av.textContent = role === 'user' ? 'V' : 'M';
    var bubble = document.createElement('div');
    bubble.className = 'personal-shopper-message__bubble';
    bubble.textContent = text;
    wrap.appendChild(av);
    wrap.appendChild(bubble);
    els.messages.appendChild(wrap);
    scrollToBottom();
  }

  function appendTyping() {
    if (!els.messages) return null;
    var id = 'ps-typing-' + Date.now();
    var wrap = document.createElement('div');
    wrap.className = 'personal-shopper-message';
    wrap.id = id;
    var av = document.createElement('div');
    av.className = 'personal-shopper-message__avatar';
    av.textContent = 'M';
    var bubble = document.createElement('div');
    bubble.className = 'personal-shopper-message__bubble personal-shopper-message__bubble--typing';
    bubble.innerHTML = '<span class="personal-shopper-typing-dot"></span><span class="personal-shopper-typing-dot"></span><span class="personal-shopper-typing-dot"></span>';
    wrap.appendChild(av);
    wrap.appendChild(bubble);
    els.messages.appendChild(wrap);
    scrollToBottom();
    return id;
  }

  function removeTyping(id) { if (!id) return; var el = document.getElementById(id); if (el) el.remove(); }

  function scrollToBottom() {
    var body = document.getElementById('PersonalShopperBody');
    if (body) body.scrollTop = body.scrollHeight;
  }

  function trackRecommendation(reco) {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({ event: 'ps_recommendation_displayed', ps_profile: reco.profile, ps_products_count: reco.products.length });
    }
  }

  function trackAtc(variantId, productTitle, productPrice) {
    var price = productPrice ? parseFloat(productPrice) / 100 : 0;
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({ event: 'ps_add_to_cart', ecommerce: { currencyCode: 'EUR', add: { products: [{ id: variantId, name: productTitle, price: price, quantity: 1, dimension1: 'PersonalShopper' }] } } });
    }
    if (typeof gtag !== 'undefined') {
      gtag('event', 'add_to_cart', { currency: 'EUR', value: price, items: [{ item_id: variantId, item_name: productTitle, item_category: 'PersonalShopper', price: price, quantity: 1 }] });
    }
  }

  function normalizeHandle(h) { return handleMap[h] || h; }

  function getLastReco() {
    for (var i = state.history.length - 1; i >= 0; i--) {
      if (state.history[i].role === 'assistant') { var r = tryParseReco(state.history[i].content); if (r) return r; }
    }
    return null;
  }

  function setSendDisabled(d) { if (els.send) els.send.disabled = d; if (els.field) els.field.disabled = d; }
  function isValidEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }

  function escHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }
  function escAttr(str) { return escHtml(str); }

  function bindEvents() {
    /* Délégation sur document pour capter les triggers même chargés après le JS */
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-personal-shopper-trigger]');
      if (trigger) { openPanel(trigger.getAttribute('data-ps-source')); return; }
      var close = e.target.closest('[data-personal-shopper-close]');
      if (close) { closePanel(); return; }
    });

    /* NB : le lien « DIAGNOSTIC » du header et le CTA Hero ne passent PAS par le
       panel (ils vont droit au Typeform). Leur attribution se fait côté
       « arrivées diagnostic » (dashboard Analytics Diagnostic), pas ici. */
    if (els.overlay) els.overlay.addEventListener('click', closePanel);
    if (els.send) els.send.addEventListener('click', sendMessage);
    if (els.field) {
      els.field.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
      });
    }
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && state.isOpen) closePanel(); });
  }

  function init() { trackDiagArrival(); initEls(); if (!els.panel) return; bindEvents(); }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }

})();